<template>
    <validation-observer ref="form" v-slot="{ meta, handleSubmit }">
        <modal
            :id="modalId"
            :title="title"
            :ok-disabled="loading || !meta.valid"
            ok-title="Confirm - Cancel My Account"
            @ok.prevent="handleSubmit(_, confirm)"
            @hide="hideModal"
            @show="clearModal"
            size="lg"
        >
            <busy-modal :show="loading"></busy-modal>
            <b-row>
                <b-col md="12">
                    What can we do better? Please send us a note (or schedule a call) to
                    <a href="mailto:support@lodgix.com">support@lodgix.com</a> before you cancel. Tell us your needs. In
                    many instances the functionality may already be present or launching in a matter of days or weeks.
                    Switching systems is a lot of work (and money) - it’s best to check with us before you leave to see
                    if we can resolve the issue before making the big decision to cancel and switch. <br /><br />
                    Per the terms of our service agreement, if your trial period has ended, your account will NOT be
                    refunded or prorated for any of remaining days left in this billing cycle.
                </b-col>
            </b-row>
            <br />
            <b-row>
                <b-col md="12">
                    If it was possible to obtain your business in the future, what would we have to provide?
                    <form-textarea v-model="object.request" rows="6"></form-textarea>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="12">
                    <div>
                        <validation-provider name="backed_up" rules="required:allowFalse" v-slot="{ handleChange }">
                            <form-checkbox v-model="object.backed_up" @change="handleChange">
                                <b>
                                    I have backed up and download my reservation data (it will not be available for
                                    downloading after cancellation).</b
                                >
                            </form-checkbox>
                        </validation-provider>
                    </div>
                    <div>
                        <validation-provider name="understand" rules="required:allowFalse" v-slot="{ handleChange }">
                            <form-checkbox v-model="object.understand" @change="handleChange">
                                <b> I understand that clicking the button below will cancel my Lodgix.com account.</b>
                            </form-checkbox>
                        </validation-provider>
                    </div>
                    <div>
                        <validation-provider
                            name="understand_two"
                            rules="required:allowFalse"
                            v-slot="{ handleChange }"
                        >
                            <form-checkbox v-model="object.understand_two" @change="handleChange">
                                <b>
                                    I understand that canceling my Lodgix.com account will also cancel all channel
                                    management feeds and disable all quoting and online booking capability on those
                                    channels. Please make efforts to coordinate with your channel representatives to
                                    avoid disruptions and ranking drops at your respective channels.</b
                                >
                            </form-checkbox>
                        </validation-provider>
                    </div>
                </b-col>
            </b-row>
        </modal>
    </validation-observer>
</template>

<script>
import API from '../../../api';
import BusyModal from '../../generic/busy-modal/busy-modal.vue';
import Modal from '../../generic/modal/modal.vue';
import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
import FormTextarea from '../../generic/form-textarea/form-textarea.vue';
import { formatResponseError } from '../../../utils/api';
import { SUBSCRIPTION_BILLING_CANCEL_SUBSCRIPTION_ENDPOINT } from '../../../endpoints';

export default {
    name: 'SubscriptionCancelModal',
    components: {
        BusyModal,
        Modal,
        FormCheckbox,
        FormTextarea,
    },
    props: {
        modalId: String,
        title: String,
    },
    data() {
        return {
            loading: false,
            object: {
                request: '',
                backed_up: null,
                understand: null,
                understand_two: null,
            },
        };
    },
    methods: {
        clearModal() {
            this.object.request = '';
            this.object.backed_up = null;
            this.object.understand = null;
            this.object.understand_two = null;
        },
        hideModal() {
            this.$bvModal.hide(this.modalId);
        },
        async confirm() {
            this.loading = true;
            try {
                await API.put(SUBSCRIPTION_BILLING_CANCEL_SUBSCRIPTION_ENDPOINT(), this.object);

                this.$emit('success-cancel');

                this.$nextTick(() => {
                    this.hideModal();
                });
            } catch (error) {
                const { generic } = formatResponseError(error);
                this.errorToast({
                    text: generic || 'Something went wrong while cancelling subscription.',
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
